// Utility: Allowed operators per property type for query builder (Palantir/Foundry compatible)
import { FilterOperator } from '../../FiltersDisplay/FilterOperation';

// Map property type to allowed operators (UI dropdown)
// String fields: text search only (no eq/lt/gt)
export const PROPERTY_TYPE_OPERATORS: Record<string, FilterOperator[]> = {
  string: [
    FilterOperator.CONTAINS,
    FilterOperator.STARTS_WITH,
    FilterOperator.IN,
    FilterOperator.CONTAINS_ANY_TERM,
    FilterOperator.CONTAINS_ALL_TERMS,
    FilterOperator.CONTAINS_ALL_TERMS_IN_ORDER,
  ],
  number: [
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS,
    FilterOperator.GREATER_THAN,
    FilterOperator.LESS_THAN,
    FilterOperator.GREATER_THAN_OR_EQUALS,
    FilterOperator.LESS_THAN_OR_EQUALS,
    FilterOperator.IS_NULL,
  ],
  date: [
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS,
    FilterOperator.GREATER_THAN,
    FilterOperator.LESS_THAN,
    FilterOperator.GREATER_THAN_OR_EQUALS,
    FilterOperator.LESS_THAN_OR_EQUALS,
    FilterOperator.IS_NULL,
  ],
  boolean: [
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS,
  ],
  array: [
    // Arrays typically support contains; other ops handled by form logic
    FilterOperator.CONTAINS,
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS,
  ],
};

// Helper: get allowed operators for a property type
export function getAllowedOperatorsForType(type: string): FilterOperator[] {
  // Fallback to string operators for unknown types
  return PROPERTY_TYPE_OPERATORS[type] || PROPERTY_TYPE_OPERATORS.string;
}